import React from 'react';
import { hot } from 'react-hot-loader';
import './index.less'

function App() {
  let { protocol, hostname } = document.location;

  let match =
    hostname.match(/(liepin|wisest|lietou|tongdao).([0-9a-z]+)$/) || [];
  let [, domain = 'liepin', suffix = 'com'] = match;
  let baseDomain = `${domain}.${suffix}`;
  let irRoot;
  let wwwRoot;
  let wowRoot;
  let html;
  function getDomain(sub) {
    return sub
      ? `${protocol}//${sub.replace(/\.$/g, '')}.${baseDomain}`
      : baseDomain;
  }
  irRoot = getDomain('ir');
  wwwRoot = getDomain('www');
  wowRoot = getDomain('wow');
  return (
    <footer id="common-footer" class="common-footer-wrap">
      <div class="common-footer-container">
        <div class="common-footer-content">
          <div class="common-footer-contact-wrap">
            <div class="common-footer-logo">
              <img
                src="//image0.lietou-static.com/img/610bb55fbd3b6c4c57db17fc02u.png"
                alt=""
              />
            </div>
            <div class="common-footer-contact-way">
              <label for="">企业服务热线和算法推荐/未成年人举报渠道：</label>
              <div class="common-footer-tel">
                <strong>400-6212-266</strong>
                <p>工作日9:00-19:00</p>
              </div>
              <p class="common-footer-email">
                <a href="mailto:jubao@liepin.com">
                  <strong>jubao@liepin.com</strong>
                </a>
              </p>
            </div>
          </div>
          <div class="common-footer-links">
            <dl>
              <dt>投资者关系</dt>
              <dd>
                <a href={`${irRoot}/index.html`} target="_blank">
                  公司简介
                </a>
              </dd>
              <dd>
                <a href={`${irRoot}/disclosure.html`} target="_blank">
                  信息披露
                </a>
              </dd>
              <dd>
                <a href={`${irRoot}/management.html`} target="_blank">
                  企业管制
                </a>
              </dd>
              <dd>
                <a href={`${irRoot}/relationalnetwork.html`} target="_blank">
                  投资者关系联络
                </a>
              </dd>
            </dl>
            <dl>
              <dt>共赢</dt>
              <dd>
                <a href={`${wowRoot}/t1007623/index.html`} target="_blank">
                  网站合作
                </a>
              </dd>
              <dd>
                <a
                  href={`${wowRoot}/t1006107/index.html?mscid=Favsk7rH`}
                  target="_blank"
                >
                  加入猎聘
                </a>
              </dd>
            </dl>
            <dl>
              <dt>产品与服务</dt>
              <dd>
                <a href={`${wwwRoot}/abroad/getabroadjob/`} target="_blank">
                  海外招聘
                </a>
              </dd>
              <dd>
                <a href={`${wowRoot}/t1005965/0996fc1c.html`} target="_blank">
                  应用权限
                </a>
              </dd>
              <dd>
                <a href={`${wowRoot}/t1007765/f4414bb7.html`} target="_blank">
                  算法推荐服务说明
                </a>
              </dd>
              <dd>
                <a href={`${wowRoot}/t1008865/87e61e66.html`} target="_blank">
                  安全防范指南
                </a>
              </dd>
              <dd>
                <a href="https://www.lebanban.com" target="_blank">
                  企业培训
                </a>
              </dd>
            </dl>
          </div>
          <div class="common-footer-spread">
            <figure>
              <figcaption>下载猎聘APP</figcaption>
              <img
                src="//image0.lietou-static.com/img/610bb55eb58af93b07b65e0302u.png"
                alt=""
              />
              <p>
                <a href="http://weibo.com/lietouwang" target="_blank">
                  关注猎聘
                  <svg
                    width="30px"
                    height="30px"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <linearGradient
                        x1="50%"
                        y1="0%"
                        x2="50%"
                        y2="100%"
                        id="prefix__a"
                      >
                        <stop stop-color="#FDEBC3" offset="0%" />
                        <stop stop-color="#F3CE61" offset="100%" />
                      </linearGradient>
                      <linearGradient
                        x1="50%"
                        y1="0%"
                        x2="50%"
                        y2="100%"
                        id="prefix__b"
                      >
                        <stop stop-color="#F0392F" offset="0%" />
                        <stop stop-color="#C82113" offset="100%" />
                      </linearGradient>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                      <path
                        d="M3.55 0h10.752a3.55 3.55 0 013.55 3.515l.112 10.898A3.55 3.55 0 0114.413 18H3.55A3.55 3.55 0 010 14.45V3.55A3.55 3.55 0 013.55 0z"
                        fill="url(#prefix__a)"
                        transform="translate(3 3)"
                      />
                      <path
                        d="M14.357 5.24c1.464-.296 3.05.137 4.125 1.272a3.988 3.988 0 01.908 4.042c-.107.312-.46.483-.789.382a.593.593 0 01-.403-.752 2.833 2.833 0 00-.645-2.87c-.765-.807-1.89-1.116-2.933-.905a.654.654 0 01-.473-.083.598.598 0 01-.272-.377.571.571 0 01.086-.45.626.626 0 01.396-.259zm.871 1.892a2.082 2.082 0 011.936.602c.503.538.638 1.273.423 1.916a.527.527 0 01-.958.072.483.483 0 01-.03-.383.926.926 0 00-.206-.937 1.024 1.024 0 00-.947-.293.535.535 0 01-.391-.069.5.5 0 01-.226-.314.485.485 0 01.072-.377.52.52 0 01.327-.217z"
                        fill="#EAA43F"
                      />
                      <path
                        d="M12.825 8.312c-.217-.063-.365-.108-.25-.392.244-.615.264-1.34 0-1.718-.498-.711-1.91-.66-3.42.174 0 0-.49.214-.366-.174.24-.771.205-1.417-.17-1.791-1.037-.968-2.989.035-4.923 1.965C2.25 7.82 1.633 9.742 1.633 11.067c0 2.534 2.67 4.06 5.854 4.06 4.173 0 7.199-2.798 7.199-4.722 0-1.162-.98-1.82-1.861-2.093z"
                        fill="url(#prefix__b)"
                        transform="translate(3 3)"
                      />
                      <path
                        d="M10.797 17.016c-2.635.238-4.91-.854-5.08-2.443-.172-1.588 1.713-3.22 4.347-3.458 2.634-.24 5.023 1.005 5.194 2.592.17 1.588-1.827 3.069-4.461 3.309z"
                        fill="#FFFAFF"
                      />
                      <path
                        d="M7.956 13.658c.546-1.014 1.83-1.533 3.085-1.234 1.297.308 1.823 1.596 1.294 2.688-.538 1.118-1.912 1.645-3.224 1.256-1.267-.375-1.71-1.675-1.155-2.71zm1.445.462a.72.72 0 100 1.44.72.72 0 000-1.44zm1.522-.277a.35.35 0 00-.406.148c-.081.136-.036.292.108.349a.353.353 0 00.416-.148c.08-.14.028-.297-.118-.349z"
                        fill="#09050D"
                      />
                    </g>
                  </svg>
                  <svg
                    width="30px"
                    height="30px"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none" fill-rule="evenodd">
                      <path
                        d="M3.55 0h10.752a3.55 3.55 0 013.55 3.515l.112 10.898A3.55 3.55 0 0114.413 18H3.55A3.55 3.55 0 010 14.45V3.55A3.55 3.55 0 013.55 0z"
                        fill="#f6f6f8"
                        transform="translate(3 3)"
                      />
                      <path
                        d="M14.357 5.24c1.464-.296 3.05.137 4.125 1.272a3.988 3.988 0 01.908 4.042c-.107.312-.46.483-.789.382a.593.593 0 01-.403-.752 2.833 2.833 0 00-.645-2.87c-.765-.807-1.89-1.116-2.933-.905a.654.654 0 01-.473-.083.598.598 0 01-.272-.377.571.571 0 01.086-.45.626.626 0 01.396-.259zm.871 1.892a2.082 2.082 0 011.936.602c.503.538.638 1.273.423 1.916a.527.527 0 01-.958.072.483.483 0 01-.03-.383.926.926 0 00-.206-.937 1.024 1.024 0 00-.947-.293.535.535 0 01-.391-.069.5.5 0 01-.226-.314.485.485 0 01.072-.377.52.52 0 01.327-.217z"
                        fill="#999"
                      />
                      <path
                        d="M12.825 8.312c-.217-.063-.365-.108-.25-.392.244-.615.264-1.34 0-1.718-.498-.711-1.91-.66-3.42.174 0 0-.49.214-.366-.174.24-.771.205-1.417-.17-1.791-1.037-.968-2.989.035-4.923 1.965C2.25 7.82 1.633 9.742 1.633 11.067c0 2.534 2.67 4.06 5.854 4.06 4.173 0 7.199-2.798 7.199-4.722 0-1.162-.98-1.82-1.861-2.093z"
                        fill="#999"
                        transform="translate(3 3)"
                      />
                      <path
                        d="M10.797 17.016c-2.635.238-4.91-.854-5.08-2.443-.172-1.588 1.713-3.22 4.347-3.458 2.634-.24 5.023 1.005 5.194 2.592.17 1.588-1.827 3.069-4.461 3.309z"
                        fill="#FFFAFF"
                      />
                      <path
                        d="M7.956 13.658c.546-1.014 1.83-1.533 3.085-1.234 1.297.308 1.823 1.596 1.294 2.688-.538 1.118-1.912 1.645-3.224 1.256-1.267-.375-1.71-1.675-1.155-2.71zm1.445.462a.72.72 0 100 1.44.72.72 0 000-1.44zm1.522-.277a.35.35 0 00-.406.148c-.081.136-.036.292.108.349a.353.353 0 00.416-.148c.08-.14.028-.297-.118-.349z"
                        fill="#999"
                      />
                    </g>
                  </svg>
                </a>
              </p>
            </figure>
          </div>
        </div>
      </div>
      <hr />
      <div class="common-footer-container">
        <div class="common-footer-cert">
          <p>
            <a
              class="police-record"
              target="_blank"
              href="https://beian.miit.gov.cn/#/Integrated/index"
            >
              津ICP备15007986号-11
            </a>
            <a
              class="police-record"
              href={`${wowRoot}/t1006533/d8b79545.html`}
              target="_blank"
            >
              ICP经营许可证：合字B2-20160007
            </a>
            <a
              class="police-record"
              href={`${wowRoot}/t1006519/813f68c2.html`}
              target="_blank"
            >
              人力资源服务许可证
            </a>
            <a
              class="police-record"
              href={`${wowRoot}/t1006517/813f68c2.html`}
              target="_blank"
            >
              营业执照
            </a>
            <a
              class="police-record"
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502035189"
            >
              <img
                src="//image0.lietou-static.com/img/610bb560b2b4a8626465ef9202u.png"
                alt="安备"
              />
              <span>京公网安备 11010502035189号</span>
            </a>
            <a href={`${wowRoot}/t1005001/0996fc1c.html`} target="_blank">
              个人信息保护政策
            </a>
            <a href={`${wowRoot}/t1005005/7dfc3910.html`} target="_blank">
              猎聘用户服务协议
            </a>
            <a href={`${wowRoot}/t1006423/11f04627.html`} target="_blank">
              投诉举报制度
            </a>
          </p>
          <p>
            Copyright © 2006-2026 liepin.com All Rights Reserved
            <a href="https://www.12377.cn/" target="_blank">
              违法和不良信息举报
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default hot(module)(App);
